import React from "react";
import { useSelector } from "react-redux";
import StudentHeader from "../Student/StudentHeader";
import FacultyHeader from "../Teacher/FacultyHeader";
import AlumniHeader from "../Alumni/AlumniHeader";

const DynamicHeader = () => {
  const { role } = useSelector((state) => state.user);

  switch (role) {
    case "student":
      return <StudentHeader />;
    case "faculty":
      return <FacultyHeader />;
    case "alumni":
      return <AlumniHeader />;
    // Add more cases for other roles as needed
    default:
      return null; // or a default header
  }
};

export default DynamicHeader;
